import styled from '@emotion/styled';
import { breakpoints } from '~/theme';

export const StyledNewsLetter = styled.div(() => ({
    [breakpoints.md]: {
        maxWidth: '30ch',
    },
}));
